import { createSelector } from "reselect";

const pendingPrivateInquiryStateSelector = (state) =>
  state.pendingArtisansPrivateInquiry;
  
const selectById = (state, itemId) => itemId;

export const pendingArtisansPrivateInquirySelector = createSelector(
  [pendingPrivateInquiryStateSelector],
  (privateInquiry) => privateInquiry.items
);

export const privateInquiryByIdSelector = createSelector(
  [pendingArtisansPrivateInquirySelector, selectById],
  (privateInquiries, _id) => {
    const privateInquiry = privateInquiries.find((item) => _id === item._id);
    if (!privateInquiry) return null;
    return privateInquiry;
  }
);
export const pendingArtisansPrivateInquiryAsListSelector = createSelector(
  [pendingArtisansPrivateInquirySelector],
  (privateInquiries) =>
    privateInquiries.map((privateInquiry) => {
      console.log(privateInquiries, 'privateInquiries')
      return {
      _id: privateInquiry._id,
      message: privateInquiry.message,
      businessName: privateInquiry.customerDetail?.businessName,
      artisanProduct: privateInquiry.artisanProduct,
      customerDetail: privateInquiry.customerDetail
      }
    })
);

export const pendingArtisansPrivateInquiryIsLoadingSelector = createSelector(
  [pendingPrivateInquiryStateSelector],
  (privateInquiry) => privateInquiry.isLoading
);

export const pendingArtisansPrivateInquiryCountSelector = createSelector(
  [pendingPrivateInquiryStateSelector],
  (privateInquiry) => privateInquiry.count
);

export const pendingArtisanPrivateInquiryByIdSelector = createSelector(
  [pendingArtisansPrivateInquirySelector, selectById],
  (artisans, _id) => {
    const pendingArtisan = artisans.find((item) => _id === item._id);
    console.log( 'found',pendingArtisan, _id)
    if (!pendingArtisan) return null;
    return pendingArtisan;
  }
);